





import { pageFactory } from '@/main/pages/pageFactory';

import { NAME } from './constants';
import { store } from './store/list';

export default pageFactory(NAME, store);
